// Systemweite Vorgabe akademischer Titel für Adresseingabe / Gegenseite /
// Beteiligte. Reine Frontend-Konstante; Backend akzeptiert weiterhin freien
// String, damit bestehende Datensätze / Sondertitel nicht brechen.

export const TITEL_OPTIONS = [
  { value: "", label: "— kein Titel —" },
  { value: "Dr.", label: "Dr." },
  { value: "Dr. Dr.", label: "Dr. Dr." },
  { value: "Dr. med.", label: "Dr. med." },
  { value: "Dr. jur.", label: "Dr. jur." },
  { value: "Dr. phil.", label: "Dr. phil." },
  { value: "Dr. rer. nat.", label: "Dr. rer. nat." },
  { value: "Prof.", label: "Prof." },
  { value: "Prof. Dr.", label: "Prof. Dr." },
  { value: "Prof. Dr. Dr.", label: "Prof. Dr. Dr." },
  { value: "Dr. h. c.", label: "Dr. h. c." },
  { value: "Dipl.-Ing.", label: "Dipl.-Ing." },
  { value: "Dipl.-Kfm.", label: "Dipl.-Kfm." },
  { value: "Dipl.-Kfr.", label: "Dipl.-Kfr." },
  { value: "Mag.", label: "Mag." },
  { value: "LL.M.", label: "LL.M." },
  { value: "MBA", label: "MBA" },
  { value: "B.Sc.", label: "B.Sc." },
  { value: "M.Sc.", label: "M.Sc." },
  { value: "B.A.", label: "B.A." },
  { value: "M.A.", label: "M.A." },
];
